import { render, staticRenderFns } from "./UploadScans.vue?vue&type=template&id=4cb2de92"
import script from "./UploadScans.vue?vue&type=script&lang=js"
export * from "./UploadScans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports